import React from 'react';

import { List, ListItemButton, Typography } from '@mui/joy';
import { observer } from 'mobx-react-lite';

import { missionPlannerStore } from '../../stores/MissionPlannerStore';

const CommandList: React.FC = () => {
  const getCommandName = (item: any, index: number) => {
    if (item.name) return item.name;
    if (item.command === 22) return 'Takeoff';
    if (item.command === 16) {
      const waypointIndex = missionPlannerStore.missionItems
        .filter((i) => i.type === 'SimpleItem' && i.command === 16)
        .findIndex((i) => i === item);
      return `Waypoint #${waypointIndex + 1}`;
    }
    return `${item.type} #${index + 1}`;
  };

  return (
    <List size='sm'>
      {missionPlannerStore.missionItems.map((item, idx) => (
        <ListItemButton
          key={idx}
          selected={missionPlannerStore.selectedIndex === idx}
          onClick={() => missionPlannerStore.selectItem(idx)}
        >
          <Typography level='body-sm'>{getCommandName(item, idx)}</Typography>
        </ListItemButton>
      ))}
    </List>
  );
};

export default observer(CommandList);
